import { IonContent, isPlatform } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { FormInput } from '@/components/FormInput';
import { InfoProtection } from '@/components/InfoProtection';
import { UiTypography } from '@/components/ui/Typography';
import { useAccount } from '@/hooks/useAccount';
import { amplitudeModule } from '@/modules/amplitude';
import { getBotSlug } from '@/modules/botSlug';
import { chatPinner } from '@/modules/chatPinner';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { OnboardingTitle } from '@/pages/Onboarding/components/Title';
import { useOnboarding } from '@/pages/Onboarding/context.tsx';
import { useBotInfoWithPreload } from '@/pages/Onboarding/Layouts/OwnAI_Trans/hooks/useTransBotInfo.ts';
import { getPerfectLookChoiceIdByTitle } from '@/pages/Onboarding/options/PerfectLook/utils/getPerfectLookChoice';
import { checkIsValidateEmail } from '@/pages/Onboarding/utils/checkIsValidEmail';
import { canLogEvents } from '@/utils/canLogEvents';

import { LayoutDataType } from '../../types';

import { EmailStyles } from './Email.styles';

export const ScreenEmail: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Email',
      });
    }
  }, []);

  const { user } = useAccount();
  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const inputRef = React.useRef<HTMLIonInputElement>(null);

  const formEmail = form.watch('email');

  const isValidEmail = checkIsValidateEmail(formEmail);

  useBotInfoWithPreload('paywall');

  React.useEffect(() => {
    if (isPlatform('android') || isPlatform('desktop')) {
      setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.setFocus();
        }
      });
      setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.setFocus();
        }
      }, 1000);
    }
  }, []);

  const handleNextStep = async (): Promise<void> => {
    if (!formEmail || !isValidEmail) return;

    const onb_data = user?.onboarding_data || {};
    const perfectLook = getPerfectLookChoiceIdByTitle(
      onb_data.perfectLook,
      true,
    );

    const slug = getBotSlug({
      perfectLook,
    });

    if (user && slug) {
      chatPinner.pin(slug, user.id);
    }

    wizard.nextStep();
  };
  return (
    <EmailStyles>
      <OnboardingNavigation />

      <IonContent>
        <OnboardingTitle className="onboarding-email-title">
          Connecting you with your <br />{' '}
          <UiTypography
            variant={'title-medium'}
            color={'secondary-static'}
            align={'center'}
          >
            perfect trans companion…
          </UiTypography>
        </OnboardingTitle>

        <div className="email-images">
          <img
            src="/assets/layout-own-ai-trans/email/circle.svg"
            alt="circle"
            className="email-circle"
          />
          <img
            src="/assets/layout-own-ai-trans/email/lady.svg"
            alt="lady"
            className="email-lady"
          />
        </div>

        <OnboardingTitle className="email-title">
          We found your perfect match.
          <br />
          She's waiting for you!
        </OnboardingTitle>

        <div className="email-input-container">
          <FormInput
            form={form}
            hidden={false}
            onSubmit={handleNextStep}
            disableButton={!isValidEmail}
            ref={inputRef}
            name="email"
            type="email"
            placeholder="Type your email"
            theme="primary"
          />
        </div>
        <div className="email-protection">
          <InfoProtection />
        </div>
      </IonContent>
    </EmailStyles>
  );
};
